import { collection, doc, getFirestore, onSnapshot, setDoc } from 'firebase/firestore';
import React, { useEffect, useState } from 'react'
import { app } from '../../util/firebase';
import {Routes,Route, Link} from 'react-router-dom';
import UpdatePharmacie from './UpdatePharmacie';
import UpdateHospital from './UpdateHospital';

const ListHospitals = (props) => {
    
    const [listPharmacies, setListPharmacies ] = useState([])
    const [posteID, setPosteID ] = useState("")

    useEffect(()=>{
        onSnapshot(collection(getFirestore(app),"users"),(snap)=>{
            setListPharmacies(snap.docs.map((snap)=> {
                let user = snap.data()
                user.id = snap.id
                return user
            }))
        })
    },[])

    const recoverArchived=(poste)=>{
            poste.isArchived = false
            setDoc(doc(getFirestore(app),"users",poste.id),poste)
            .then((res)=> alert('La pharmacie a bien été récupèrée'))
            .catch(err=>alert(err))
    }

    const allHospitals = ()=>{
        let list = listPharmacies.filter(user=> user.status === 'hospital' && user.isArchived === props.isArchived)
        return list.map((poste,index)=>{
            return(
                <tr key={index}>
                    <td><img style={{maxHeight:'40px'}} className="product-img" src={poste.imgSrc}  alt="" /></td>
                    <td>{poste.userName}</td>
                    <td>{poste.adresse}</td>
                    <td>{poste.email}</td>
                    
                    {
                        props.isArchived?
                        <td >
                            <button className="btn btn-warning" onClick={e=>recoverArchived(poste)}>Recupérer</button>
                        </td>
                        :
                        <td>
                            <Link to="updateHospital">
                                <button className="btn btn-primary" onClick={e=>setPosteID(poste.id)}>Modifier</button>
                            </Link>
                        </td>
                    }
                </tr>
            )
        })
    }

    return (
        <div>
            <Routes>
                <Route path='' element={
                    <div className="col-12 bg-light p-3">
                        <table className="table table-striped table-hover border rounded">
                            <thead>
                                <tr className='bg-white '>
                                    <td>Image </td>
                                    <td>Nom Complet </td>
                                    <td>Adresse </td>
                                    <td>Email </td>
                                    <td>Action </td>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    allHospitals()
                                }
                            </tbody>
                        </table>
                    </div>
           
                }></Route>
                <Route path='updateHospital' element={<UpdateHospital posteID = {posteID}/>}></Route>
            </Routes>
        </div>
    );
};

export default ListHospitals;